// Increment 39: reacceptance gate. When a signed-in member owes acceptance of an
// updated ToS/Privacy version, show a blocking modal that must be accepted before
// they can continue taking actions. Mounted globally in the app Shell.
import { useEffect, useState } from "react";
import { ShieldCheck, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function LegalGate() {
  const { user } = useAuth();
  const [status, setStatus] = useState<any | null>(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function check() {
    if (!user || user.userType === "admin") { setStatus(null); return; }
    try { setStatus(await api.legalStatus()); } catch { setStatus(null); }
  }
  useEffect(() => { check(); /* eslint-disable-next-line */ }, [user?.id]);

  if (!user || user.userType === "admin" || !status?.needsAcceptance) return null;

  const pending: string[] = [];
  if (status.terms?.needsAcceptance) pending.push("Terms of Service");
  if (status.privacy?.needsAcceptance) pending.push("Privacy Policy");

  async function accept() {
    setBusy(true); setErr(null);
    try { await api.acceptLegal(); await check(); }
    catch (e: any) { setErr(e?.message || "Could not record acceptance."); }
    finally { setBusy(false); }
  }

  return (
    <div className="fixed inset-0 z-[100] bg-navy/60 flex items-center justify-center p-4" data-testid="legal-gate">
      <div className="card p-6 max-w-md w-full">
        <div className="flex items-center gap-2 mb-2"><ShieldCheck className="w-5 h-5 text-brand-red" /><h2 className="text-lg font-extrabold text-navy">We've updated our {pending.length > 1 ? "policies" : "policy"}</h2></div>
        <p className="text-sm text-navy/80">
          To keep using KontrataPH, please review and accept our updated {pending.join(" and ")}.
        </p>
        <ul className="mt-3 space-y-1 text-sm">
          {status.terms?.needsAcceptance && <li><a href="/legal/terms" target="_blank" rel="noreferrer" className="text-brand-red font-semibold hover:underline">Read the Terms of Service (v{status.terms.current})</a></li>}
          {status.privacy?.needsAcceptance && <li><a href="/legal/privacy" target="_blank" rel="noreferrer" className="text-brand-red font-semibold hover:underline">Read the Privacy Policy (v{status.privacy.current})</a></li>}
        </ul>
        {err && <p className="text-sm text-brand-red mt-2">{err}</p>}
        <button onClick={accept} disabled={busy} className="btn-red w-full mt-4 disabled:opacity-60" data-testid="legal-accept">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <ShieldCheck className="w-4 h-4" />}I agree and accept
        </button>
      </div>
    </div>
  );
}
